import React from "react";
import "./tableSkeleton.css";

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  rowHeight?: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 4,
  columns = 2,
  rowHeight = 14,
}) => {
  return (
    <div className="table-skeleton">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div className="skeleton-row" key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div
              key={colIndex}
              className="skeleton-cell"
              style={{ height: rowHeight }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
